import { DatePipe, NgForOf, NgIf, NgClass, UpperCasePipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Tooltip } from 'primeng/tooltip';
import { environment } from '../../../environments/environment';
import { App } from '../../app';
import { ECollection } from '../../enums/ECollection';
import { EShippingStatus } from '../../enums/EShippingStatus';
import { IQueryFormat } from '../../enums/types';
import { IOrders, IOrders_P, IOrders_S, IOrdProductDetailsArr } from '../../interfaces/IOrder';
import { IUser_S } from '../../interfaces/IUser';
import { ITickets, ITickets_P } from '../../interfaces/ITickets';
import { ITicketMessages, ITicketMessages_P } from '../../interfaces/ITicketMessages';
import { AuthService } from '../../service/auth.service';
import { NotificationService } from '../../service/notification.service';
import { OrdersService } from '../../service/orders.service';
import { TicketsService } from '../../service/tickets.service';
import { TicketMessagesService } from '../../service/ticket-messages.service';
import * as _ from 'lodash';
import { Dialog } from 'primeng/dialog';

declare let moment: any;

@Component({
    selector: 'app-orders',
    standalone: true,
    templateUrl: './orders.html',
    imports: [ FormsModule, NgForOf, DatePipe, Dialog, NgIf, Tooltip, NgClass, UpperCasePipe ],
    styleUrl: 'orders.scss'
})
export class Orders implements OnInit {
    loading: boolean = false;
    showStatus: boolean = false;
    trackBy: string = 'orderId';
    orderIdOrAWS: string = '';
    topFileUrl: string = 'assets/website-images/HomepageSliderImage1920x1200.jpg';
    visible: boolean = false;
    orderDetails: IOrders[] = [];
    searchOrderDetails: IOrders[] = [];     // after filtering
    pagedOrders: IOrders[] = [];            // after pagination

    pageSize = 10;
    currentPage = 1;
    totalPages = 1;
    totalPagesArray: number[] = [];

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.app.isScrolled = window.scrollY < 99999;
        this.app.hideTopStrip = window.scrollY < 99999;
    }

    monthSelected: string = 'LAST_MONTH';
    trackOrderDetails: IOrders_P = <any>{};
    viewOrderDetails: IOrders_P = <any>{};
    EShippingStatus = EShippingStatus;

    // Issue with Order feature
    showIssueDialog: boolean = false;
    selectedProducts: number[] = [];
    issueForm = { subject: '', description: '' };
    isSubmittingIssue: boolean = false;

    // Ticket & Messaging feature
    currentTicket: ITickets | null = null;
    showConversationThread: boolean = false;
    ticketMessages: ITicketMessages[] = [];
    newMessage: string = '';
    isLoadingTicket: boolean = false;
    isLoadingMessages: boolean = false;
    isSendingMessage: boolean = false;

    constructor(private app: App,
                private authService: AuthService,
                private cd: ChangeDetectorRef,
                private ns: NotificationService,
                private router: Router,
                private ordersService: OrdersService,
                private ticketsService: TicketsService,
                private ticketMessagesService: TicketMessagesService) {
    }

    ngOnInit() {
        if (!this.authService.gUser?._id) this.router.navigate([ '/' ]);
        this.app.isScrolled = true;
        this.app.hideTopStrip = true;
        this.visible = false;

        const items = document.querySelectorAll(".list-group-item");
        items.forEach(item => {
            item.addEventListener("click", () => {
                items.forEach(i => i.classList.remove("active-category"));
                item.classList.add("active-category");
            });
        });

        setTimeout(() => {
            this.loadOrderDetails().then();
            // this.init();
        }, 100);
    }

    // init() {
    //     const trackTab = document.getElementById("trackTab");
    //     const historyTab = document.getElementById("historyTab");
    //     const trackSection = document.getElementById("trackSection");
    //     const historySection = document.getElementById("historySection");
    //
    //     const activateTab = (tab: string) => {
    //         if (tab === "track") {
    //             trackTab?.classList.add("active");
    //             historyTab?.classList.remove("active");
    //             trackSection?.classList.remove("d-none");
    //             historySection?.classList.add("d-none");
    //         }
    //         if (tab === 'history') {
    //             trackTab?.classList.remove("active");
    //             historyTab?.classList.add("active");
    //             trackSection?.classList.add("d-none");
    //             historySection?.classList.remove("d-none");
    //             this.loadOrderDetails().then();
    //         }
    //     };
    //
    //     trackTab?.addEventListener("click", () => activateTab("track"));
    //     historyTab?.addEventListener("click", () => activateTab("history"));
    // }

    async trackOrder(trackId: string) {
        // if (!this.orderIdOrAWS && !trackId) return this.ns.showError('Please Enter OrderId Or AWS.');
        try {
            this.loading = true;
            this.trackOrderDetails = <any>{};
            let findObj = {
                userId: this.authService.gUser?._id,
                orderIdOrAWS: this.orderIdOrAWS || trackId,
                type: this.trackBy || 'orderId'
            };
            this.trackOrderDetails = await this.ordersService.trackOrder(findObj);
            if (this.trackOrderDetails.ord_order_placed_dt) this.trackOrderDetails.ord_order_placed_dt = <any>`${ moment(this.trackOrderDetails.ord_order_placed_dt).format('DD') } ${ moment(this.trackOrderDetails.ord_order_placed_dt).format('MMM') } ${ moment(this.trackOrderDetails.ord_order_placed_dt).format('YYYY') } ${ moment(this.trackOrderDetails.ord_order_placed_dt).format('hh:mm A') }`;
            if (this.trackOrderDetails.ord_processing_dt) this.trackOrderDetails.ord_processing_dt = <any>`${ moment(this.trackOrderDetails.ord_processing_dt).format('DD') } ${ moment(this.trackOrderDetails.ord_processing_dt).format('MMM') } ${ moment(this.trackOrderDetails.ord_processing_dt).format('YYYY') } ${ moment(this.trackOrderDetails.ord_processing_dt).format('hh:mm A') }`;
            if (this.trackOrderDetails.ord_shipped_dt) this.trackOrderDetails.ord_shipped_dt = <any>`${ moment(this.trackOrderDetails.ord_shipped_dt).format('DD') } ${ moment(this.trackOrderDetails.ord_shipped_dt).format('MMM') } ${ moment(this.trackOrderDetails.ord_shipped_dt).format('YYYY') } ${ moment(this.trackOrderDetails.ord_shipped_dt).format('hh:mm A') }`;
            if (this.trackOrderDetails.ord_delivered_dt) this.trackOrderDetails.ord_delivered_dt = <any>`${ moment(this.trackOrderDetails.ord_delivered_dt).format('DD') } ${ moment(this.trackOrderDetails.ord_delivered_dt).format('MMM') } ${ moment(this.trackOrderDetails.ord_delivered_dt).format('YYYY') } ${ moment(this.trackOrderDetails.ord_delivered_dt).format('hh:mm A') }`;
            this.showStatus = true;
            if (this.trackOrderDetails.tracking_data && this.trackOrderDetails.tracking_data.tracking_data && this.trackOrderDetails.tracking_data.tracking_data.error) {
                this.loading = false;
                return this.ns.showError(this.trackOrderDetails.tracking_data.tracking_data.error);
            }
            this.loading = false;
        } catch (e: any) {
            this.loading = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to track order.');
        }
        this.cd.detectChanges();
    }

    async loadOrderDetails() {
        this.visible = false;
        this.orderDetails = [];
        let findObj = <IOrders_P>{
            active: true,
            ord_user_id: <any>this.authService.gUser?._id
        };

        if (this.monthSelected === 'LAST_MONTH') {
            findObj.createdAt = <any>{
                $gte: moment().startOf('month').toDate(),
                $lte: moment().endOf('day').toDate(),
            };
        }
        if (this.monthSelected === 'LAST_3_MONTH') {
            findObj.createdAt = <any>{
                $gte: moment().subtract(2, 'months').startOf('month').toDate(),
                $lte: moment().endOf('day').toDate(),
            };
        }
        if (this.monthSelected === 'LAST_6_MONTH') {
            findObj.createdAt = <any>{
                $gte: moment().subtract(2, 'months').startOf('month').toDate(),
                $lte: moment().endOf('day').toDate(),
            };
        }
        if (this.monthSelected === 'LAST_12_MONTH') {
            findObj.createdAt = <any>{
                $gte: moment().subtract(11, 'months').startOf('month').toDate(),
                $lte: moment().endOf('day').toDate(),
            };
        }


        let query = <IQueryFormat>{
            find: findObj,
            select: <IOrders_S>{
                createdAt: 1,
                ord_product_details_arr: 1,
                ord_total_amount_num: 1,
                ord_shipping_charge_num: 1,
                ord_sub_total_amount_num: 1,
                ord_discount_num: 1,
                ord_orderId_str: 1,
                ord_shipment_status_str: 1,
            },
            sort: <IOrders_S>{ createdAt: -1 },
            limit: 1000
        };
        let resp = await this.ordersService.query(query);
        for (let item of resp) {
            // if (item.ord_shipment_status_str === EShippingStatus.ORDER_PLACED) item.ord_shipment_status_str = 'Order Placed';
            // if (item.ord_shipment_status_str === EShippingStatus.SHIPPED) item.ord_shipment_status_str = 'Shipped';
            // if (item.ord_shipment_status_str === EShippingStatus.PROCESSING) item.ord_shipment_status_str = 'Processing';
            // if (item.ord_shipment_status_str === EShippingStatus.DELIVERED) item.ord_shipment_status_str = 'Delivered';
            item.product_name = item.ord_product_details_arr?.map((e: IOrdProductDetailsArr) => e.ord_product_name_str).join(', ');
            item.quantity = _.sumBy(item.ord_product_details_arr, 'ord_quantity_num') || 0;
            item.createdAt = `${ moment(item.createdAt).format('MMMM') } ${ moment(item.createdAt).format('DD') }, ${ moment(item.createdAt).format('YYYY') }`;
        }
        this.orderDetails = resp;
        this.searchOrderDetails = this.orderDetails;
        this.currentPage = 1;
        this.updatePage();
        this.loading = false;
        this.cd.detectChanges();
    }

    searchOrderFun(text: string) {
        if (!text) {
            this.searchOrderDetails = this.orderDetails;
        } else {
            const lower = text.toLowerCase();
            this.searchOrderDetails = this.orderDetails.filter(order => {
                return order.product_name?.toLowerCase().includes(lower) ||
                    order.ord_orderId_str?.toLowerCase().includes(lower);
            });
        }

        this.currentPage = 1;
        this.updatePage();
        this.cd.detectChanges();
    }

    async showDialog(order: IOrders) {
        this.showStatus = false;
        this.loading = true;
        this.viewOrderDetails = <any>{};
        this.viewOrderDetails = await this.ordersService.getByIdAndDeep(<any>order._id, JSON.stringify(
            [
                {
                    s_key: 'ord_user_id',
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.SW_USERS,
                    t_key: "_id",
                    select: <IUser_S>{
                        usr_first_name_str: 1,
                        usr_last_name_str: 1,
                        usr_mobile_number_num: 1,
                        usr_email_str: 1
                    }
                },
            ]
        ));
        if (this.viewOrderDetails && this.viewOrderDetails._id) this.visible = true;
        if (this.viewOrderDetails.ord_order_placed_dt) this.viewOrderDetails.ord_order_placed_dt = <any>`${ moment(this.viewOrderDetails.ord_order_placed_dt).format('DD') } ${ moment(this.viewOrderDetails.ord_order_placed_dt).format('MMM') } ${ moment(this.viewOrderDetails.ord_order_placed_dt).format('YYYY') } ${ moment(this.viewOrderDetails.ord_order_placed_dt).format('hh:mm A') }`;
        if (this.viewOrderDetails.ord_processing_dt) this.viewOrderDetails.ord_processing_dt = <any>`${ moment(this.viewOrderDetails.ord_processing_dt).format('DD') } ${ moment(this.viewOrderDetails.ord_processing_dt).format('MMM') } ${ moment(this.viewOrderDetails.ord_processing_dt).format('YYYY') } ${ moment(this.viewOrderDetails.ord_processing_dt).format('hh:mm A') }`;
        if (this.viewOrderDetails.ord_shipped_dt) this.viewOrderDetails.ord_shipped_dt = <any>`${ moment(this.viewOrderDetails.ord_shipped_dt).format('DD') } ${ moment(this.viewOrderDetails.ord_shipped_dt).format('MMM') } ${ moment(this.viewOrderDetails.ord_shipped_dt).format('YYYY') } ${ moment(this.viewOrderDetails.ord_shipped_dt).format('hh:mm A') }`;
        if (this.viewOrderDetails.ord_delivered_dt) this.viewOrderDetails.ord_delivered_dt = <any>`${ moment(this.viewOrderDetails.ord_delivered_dt).format('DD') } ${ moment(this.viewOrderDetails.ord_delivered_dt).format('MMM') } ${ moment(this.viewOrderDetails.ord_delivered_dt).format('YYYY') } ${ moment(this.viewOrderDetails.ord_delivered_dt).format('hh:mm A') }`;
        this.loading = false;
        this.cd.detectChanges();
    }


    // filterByMonth(event: Event) {
    //     const value = +(event.target as HTMLSelectElement).value;
    //     const cutoff = moment().subtract(value, 'months');
    //     this.searchOrderDetails = this.orderDetails.filter(o =>
    //         moment(o.createdAt, 'MMMM DD, YYYY').isAfter(cutoff)
    //     );
    //     this.currentPage = 1;
    //     this.updatePage();
    // }

    // --- pagination logic ---
    updatePage() {
        this.totalPages = Math.ceil(this.searchOrderDetails.length / this.pageSize) || 1;
        this.totalPagesArray = Array.from({ length: this.totalPages }, (_, i) => i + 1);

        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.pagedOrders = this.searchOrderDetails.slice(start, end);
    }

    goToPage(page: number) {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
        this.updatePage();
    }

    changePageSize(event: Event) {
        this.pageSize = +(event.target as HTMLSelectElement).value;
        this.currentPage = 1;
        this.updatePage();
    }

    // Issue with Order Feature Methods
    async openIssueDialog() {
        try {
            if (!this.viewOrderDetails._id) {
                this.ns.showError('Order information not available');
                return;
            }

            this.isLoadingTicket = true;
            // Check if a ticket already exists for this order
            const existingTicket = await this.ticketsService.getTicketByOrderId(
                this.viewOrderDetails._id
            );
            
            if (existingTicket) {   
                // Ticket exists - load conversation thread
                this.currentTicket = existingTicket;
                this.showIssueDialog = false;
                await this.openTicketThread();
            } else {
                // No ticket exists - show form to create new one
                this.selectedProducts = [];
                this.issueForm = { subject: '', description: '' };
                this.currentTicket = null;
                this.showIssueDialog = true;
            }
            this.isLoadingTicket = false;
            this.cd.detectChanges();
        } catch (e: any) {
            this.isLoadingTicket = false;
            this.ns.showErrorFromResponse(e.error || e, 'Failed to load issue information');
            this.cd.detectChanges();
        }
    }

    closeIssueDialog() {
        this.showIssueDialog = false;
        this.selectedProducts = [];
        this.issueForm = { subject: '', description: '' };
        this.cd.detectChanges();
    }

    toggleProductSelection(index: number) {
        const idx = this.selectedProducts.indexOf(index);
        if (idx > -1) {
            this.selectedProducts.splice(idx, 1);
        } else {
            this.selectedProducts.push(index);
        }
        this.cd.detectChanges();
    }

    isProductSelected(index: number): boolean {
        return this.selectedProducts.includes(index);
    }

    async submitIssue() {
        if (this.selectedProducts.length === 0) {
            this.ns.showError('Please select at least one product');
            return;
        }

        if (!this.issueForm.subject.trim()) {
            this.ns.showError('Please enter an issue subject');
            return;
        }

        if (!this.issueForm.description.trim()) {
            this.ns.showError('Please enter an issue description');
            return;
        }

        try {
            this.isSubmittingIssue = true;

            // Prepare selected products data
            const selectedProductDetails = this.selectedProducts.map(
                index => this.viewOrderDetails.ord_product_details_arr?.[index]
            );
            // Generate unique issue ID
            const issueId = `ISS-${Date.now()}-${Math.random().toString(36).substr(2, 9).toUpperCase()}`;

            // Create ticket payload
            const ticketPayload: ITickets_P = {
                issue_id: issueId,
                order_id: this.viewOrderDetails._id!,
                ord_orderId_str: this.viewOrderDetails.ord_orderId_str,
                user_id: this.authService.gUser?._id as any,
                status: 'OPEN',
                products_arr: selectedProductDetails as any,
                subject: this.issueForm.subject,
                description: this.issueForm.description,
            };
            console.log('Creating ticket with payload:', ticketPayload);
            // Create ticket in database
            const createdTicket = await this.ticketsService.createTicket(ticketPayload);
            this.currentTicket = createdTicket;

            this.ns.showSuccess(`Issue reported successfully. Issue #${createdTicket.issue_id}`);
            this.closeIssueDialog();
            this.isSubmittingIssue = false;
            this.cd.detectChanges();
        } catch (e: any) {
            this.isSubmittingIssue = false;
            this.ns.showErrorFromResponse(e.error || e, 'Failed to submit issue');
            this.cd.detectChanges();
        }
    }

    // Ticket Conversation Thread Methods
    async openTicketThread() {
        try {
            if (!this.currentTicket) {
                this.ns.showError('Ticket information not available');
                return;
            }

            this.isLoadingMessages = true;
            this.showConversationThread = true;

            // Load messages for this ticket
            this.ticketMessages = await this.ticketMessagesService.getTicketMessages(
                this.currentTicket.issue_id
            );

            this.isLoadingMessages = false;
            this.cd.detectChanges();
        } catch (e: any) {
            this.isLoadingMessages = false;
            this.ns.showErrorFromResponse(e.error || e, 'Failed to load conversation');
            this.cd.detectChanges();
        }
    }

    closeConversationThread() {
        this.showConversationThread = false;
        this.currentTicket = null;
        this.ticketMessages = [];
        this.newMessage = '';
        this.cd.detectChanges();
    }

    async sendMessage() {
        if (!this.newMessage.trim()) {
            this.ns.showError('Please enter a message');
            return;
        }

        if (!this.currentTicket) {
            this.ns.showError('Ticket information not available');
            return;
        }

        if (this.currentTicket.status !== 'OPEN') {
            this.ns.showError('Cannot send message to a closed/resolved ticket');
            return;
        }

        try {
            this.isSendingMessage = true;

            // Generate unique message ID
            const messageId = `MSG-${Date.now()}-${Math.random().toString(36).substr(2, 9).toUpperCase()}`;

            // Create message payload
            const messagePayload: ITicketMessages_P = {
                message_id: messageId,
                issue_id: this.currentTicket.issue_id,
                sender_type: 'user',
                sender_id: this.authService.gUser?._id,
                message: this.newMessage
            };

            // Create message in database
            const createdMessage = await this.ticketMessagesService.createMessage(messagePayload);

            // Add to local messages array
            this.ticketMessages.push(createdMessage);
            this.newMessage = '';

            // Scroll to bottom of messages
            setTimeout(() => {
                const messagesContainer = document.querySelector('.conversation-messages');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }
            }, 100);

            this.isSendingMessage = false;
            this.cd.detectChanges();
        } catch (e: any) {
            this.isSendingMessage = false;
            this.ns.showErrorFromResponse(e.error || e, 'Failed to send message');
            this.cd.detectChanges();
        }
    }

    async checkAndRefreshTicketStatus() {
        try {
            if (!this.currentTicket?._id) return;

            const updatedTicket = await this.ticketsService.getTicketById(this.currentTicket._id);
            this.currentTicket = updatedTicket;
            this.cd.detectChanges();
        } catch (e: any) {
            console.error('Failed to refresh ticket status:', e);
        }
    }
}
